<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #industryInput
          formControlName="industry" 
          [matAutocomplete]="industryAC" 
          [placeholder]="'LABEL_INDUSTRY_TYPE' | translate"
          (focus)="!industryAC.isOpen && getInitialValues('industry')" 
          (blur)="checkAutocompleteObject(form, 'industry')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_industry_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="industryInput.blur(); clearForm($event)"
          *ngIf="industryInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!industryInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_industry_dropdown"
          [displayWith]="displayFn" 
          #industryAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); industryInput.blur()"
          (opened)="autocompleteScroll('industry','industryACRef','industryACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.industry && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_industry_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.industry" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('industry').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('industry').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_INDUSTRY_TYPE' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>